import global from '@/assets/js/global'
import axios from 'axios'

const path = 'firestoreSchool/QA'

/*
 *  QAS
 */

const get = async (params, token) => {
  const options = {
    params,
    headers: { authorization: token },
  }
  const res = await axios.get(`${global.server}${path}`, options)
  return res.data
}

const put = async (body, token) => {
  const options = {
    headers: { authorization: token },
  }
  const res = await axios.put(`${global.server}${path}`, body, options)
  return res.data
}

export default {
  get,
  put,
}
